import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';

const ContactButton = () => {
  const { t } = useTranslatedContent('common');

  return (
    <a
      href="#contact"
      className="hidden md:inline-flex bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200"
    >
      {t('nav.contact')}
    </a>
  );
};

export default ContactButton;